import type { Sponsor } from "../components/sponsors/SponsorBar";

/* ================= PRIMARY SPONSORS =================
   Used in top sponsor bar across premium pages
===================================================== */
export const primarySponsors: Sponsor[] = [
  {
    name: "Official Rugby Partner",
    url: "#",
  },
];

/* ================= SECONDARY SPONSORS =================
   Used in bottom bar on core pages
======================================================== */
export const secondarySponsors: Sponsor[] = [
  {
    name: "Travel Partner",
    url: "#",
  },
  {
    name: "Official Merch",
    url: "#",
  },
];

/* ================= UTILITY PAGE SPONSORS =================
   Used on flights, hotels, tickets, etc.
   Later replaced or mixed with AdSense
=========================================================== */
export const utilitySponsors: Sponsor[] = [
  {
    name: "Matchday Deals",
    url: "#",
  },
];
